(() => {
  const init = () => {
    const bar = document.querySelector('[data-varaari-mobile-purchase]');
    const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!bar || !productInfo || bar.dataset.ready === 'true') return;

    const addProxy = bar.querySelector('[data-varaari-add]');
    const buyProxy = bar.querySelector('[data-varaari-buy]');
    const findAdd = () => productInfo.querySelector('[id^="ProductSubmitButton-"]');
    const findBuy = () => productInfo.querySelector('.shopify-payment-button__button');

    const sync = () => {
      const addButton = findAdd();
      const buyButton = findBuy();
      addProxy.disabled = !addButton || addButton.disabled;
      buyProxy.disabled = !addButton || addButton.disabled;
      bar.hidden = false;
      if (addButton?.querySelector('span')) addProxy.textContent = addButton.querySelector('span').textContent.trim();
      if (buyButton?.disabled) buyProxy.disabled = true;
    };

    addProxy.addEventListener('click', () => findAdd()?.click());
    buyProxy.addEventListener('click', () => {
      const buyButton = findBuy();
      if (buyButton) buyButton.click();
      else productInfo.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    new MutationObserver(sync).observe(productInfo, { childList: true, subtree: true, attributes: true });
    bar.dataset.ready = 'true';
    sync();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

